import { render, staticRenderFns } from "./goldsilvermovesettle.vue?vue&type=template&id=2b175d32&scoped=true&"
import script from "./goldsilvermovesettle.vue?vue&type=script&lang=js&"
export * from "./goldsilvermovesettle.vue?vue&type=script&lang=js&"
import style0 from "./goldsilvermovesettle.vue?vue&type=style&index=0&id=2b175d32&scoped=true&lang=scss&"
import style1 from "./goldsilvermovesettle.vue?vue&type=style&index=1&lang=css&"
import style2 from "./goldsilvermovesettle.vue?vue&type=style&index=2&id=2b175d32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b175d32",
  null
  
)

export default component.exports